import React from "react";
import {LibraryDomainUseDTO, LibraryDTO, LibraryGoalUseDTO, LibraryIndicatorUseDTO} from "../../../models/library";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";
import {Box} from "@material-ui/core";
import {InfoActionButton} from "../../common/buttons";
import {IndicatorDialog} from "../../values/dialogs/IndicatorDialog";

interface LibraryIndicatorBrowserProps {
    library: LibraryDTO;
    libraryDomainUse: LibraryDomainUseDTO;
    libraryGoalUse: LibraryGoalUseDTO;
    libraryIndicatorUse: LibraryIndicatorUseDTO;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        indicatorRow: {
            display: "flex",
            alignItems: "center",
            padding: `${theme.spacing(1)}px ${theme.spacing(2)}px ${theme.spacing(1)}px ${theme.spacing(7)}px`,
            borderBottom: "1px solid #F9FAFB",
            backgroundColor: "#FAFAFA",
            "&:hover": {
                backgroundColor: "#F3F4F6",
            },
        },
        indicatorName: {
            flexGrow: 1,
            fontSize: "0.8125rem",
            color: "#6B7280",
        },
    })
);

export const LibraryIndicatorBrowser: React.FC<LibraryIndicatorBrowserProps> = (
    props: LibraryIndicatorBrowserProps
) => {
    const classes = useStyles();
    const [infoOpen, setInfoOpen] = React.useState(false);

    return (
        <Box className={classes.indicatorRow}>
            <Box className={classes.indicatorName}>{props.libraryIndicatorUse.indicator.name}</Box>
            <InfoActionButton onClick={() => setInfoOpen(true)} />
            <IndicatorDialog
                indicator={props.libraryIndicatorUse.indicator}
                handleClose={() => setInfoOpen(false)}
                open={infoOpen}
            />
        </Box>
    );
};
